/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const bootstrapModal = function (container, options) {
  let buttonsMarkUp = '';
  const title = options.title ? options.title : '';
  const width = options.width ? 'style="max-width:' + options.width + '!important;"' : '';
  const buttons = options.buttons;

  if (buttons && Object.keys(buttons).length > 0) {
    buttonsMarkUp += '<div class="modal-footer">';
    $(container).off('click', '#sorModalCenter button.action');
    for (let x = 0; x < Object.keys(buttons).length; x += 1) {
      const key = Object.keys(buttons)[x];
      buttonsMarkUp += '<button type="button" class="btn btn-primary action"  data-id="' + key + '">' + key + '</button>';
      $(container).on('click', '#sorModalCenter button.action[data-id="' + key + '"]', buttons[key]);
    }
    buttonsMarkUp += '</div>';
  }

  const bootstrap = `<div class="modal fade" id="sorModalCenter" tabindex="-1" role="dialog" aria-labelledby="sorModalCenter" aria-hidden="true">
             <div class="modal-dialog modal-dialog-centered" ${width}  role="document">
                 <div class="modal-content">
                     <div class="modal-header">
                         <h5 class="modal-title" id="exampleModalLongTitle">${title}</h5>
                         <button
                         type="button"
                         class="btn-close"
                         data-dismiss="modal">
                         <span aria-hidden="true">&times;</span>
                       </button>
                     </div>
                     <div class="modal-body">
                         ${container.html()}
                     </div>
                     ${buttonsMarkUp}
                 </div>
             </div>
         </div>`;

  container.html(bootstrap);
  container.find('.modal').on('shown.bs.modal', function () {
    const subscriptionModals = $('#subscriptionview, #orderview');
    if (subscriptionModals.length > 0 && !container.is(subscriptionModals)) {
      container.siblings('.modal-backdrop').last().css('z-index', '1060');
      container.find('.modal').css('z-index', '1070');
    }
  });
  container.find('.modal').modal({
    backdrop: 'static'
  });
  container.find('.modal').modal('show');
  container.find('.modal').on('hidden.bs.modal', function () {
    container.remove();
    if ($('#subscriptionview, #orderview, #error-model, #save-error').length > 0) {
      $('body').addClass('modal-open');
    }
  });

  container.find('.card.accordion-section').on('click', function () {
    $(this).toggleClass('expanded');
  });
};

const createModal = function (container, options) {
  const optionsRef = options;
  if (options.buttons && Object.keys(options.buttons).length > 0) {
    const buttons = {};
    for (let x = 0; x < Object.keys(optionsRef.buttons).length; x += 1) {
      const key = Object.keys(optionsRef.buttons)[x];
      if (key.indexOf('SOR_GLOBAL_') > -1) {
        buttons[SmartOrderRefillSettings.Resources[key]] = options.buttons[key];
      } else {
        buttons[key] = options.buttons[key];
      }
    }
    optionsRef.buttons = buttons;
  }

  if (SmartOrderRefillSettings.ModalType === 'dialog') {
    $(container).dialog(options);
    $(container).parents('.ui-dialog').addClass('sor-modal-wrapper');
    $('.sor-modal-wrapper .ui-dialog-titlebar-close').hide();
    $('#ui-id-1').css('white-space', 'pre-wrap');
  } else {
    bootstrapModal(container, options);
  }
};

const closeModal = function () {
  if (SmartOrderRefillSettings.ModalType === 'dialog') {
    $(this).closest('.ui-dialog-content').dialog('close');
  } else {
    let modal = $(this).closest('.modal');
    if (modal.length === 0) {
      modal = $(this).find('.modal');
    }
    modal.modal('hide');
    $('.modal').on('hidden.bs.modal', function () {
      if ($('.modal:visible').length) {
        $('body').addClass('modal-open');
      }
    });
  }
};

const createContainer = function (selector) {
  let $target;
  let id;
  if (jQuery.type(selector) === 'string') {
    if (selector.indexOf('#') === 0) {
      $target = $(selector, document);
      $target.selector = selector;
    } else {
      $target = $('#' + selector, document);
      $target.selector = '#' + selector;
    }
  } else if (selector instanceof jQuery) {
    $target = selector;
  }

  if ($target && $target.length === 0) {
    if ($target.selector && $target.selector.indexOf('#') === 0) {
      id = $target.selector.substr(1);
      $target = $('<div>').attr('id', id).appendTo('body');
    }
  }
  return $target;
};

const initErrorModal = function (content, refresPage) {
  const $container = createContainer('#error-model');
  const options = {
    autoOpen: true,
    modal: true,
    title: SmartOrderRefillSettings.Resources.SOR_ERROR_TITLE,
    width: '25rem',
    buttons: {
      SOR_GLOBAL_OK: function (refresPageOverride) {
        if (refresPageOverride) {
          window.location = SmartOrderRefillSettings.Urls.manageOrders;
        } else {
          window.location.reload();
        }
      }.bind($container, refresPage)
    }
  };

  $container.html('<h3>' + content + '</h3>');
  createModal($container, options);
};

const initWarningModal = function (content) {
  const $container = createContainer('#warning-model');
  const options = {
    autoOpen: true,
    modal: true,
    title: SmartOrderRefillSettings.Resources.SOR_WARNING_TITLE,
    width: '25rem',
    buttons: {
      SOR_GLOBAL_OK: closeModal
    }
  };

  $container.html('<h3>' + content + '</h3>');
  createModal($container, options);
};

module.exports = {
  bootstrapModal: bootstrapModal,
  createContainer: createContainer,
  createModal: createModal,
  closeModal: closeModal,
  initErrorModal: initErrorModal,
  initWarningModal: initWarningModal
};
